import { FC } from 'react'
import { FormControl, FormControlProps } from '@mui/material'

const FormControlWrapper: FC<FormControlProps> = ({ ...props }) => (
  <FormControl {...props} />
)

export default FormControlWrapper
